<div>


    <div class="panel">
        <div class="panel--search" *ngIf="!showSearch" [@enterAnimation]>
            <div class="panel__header">
                <a class="button button--primary" style="margin-bottom: 16px; display: none;">
                    <span class="button__text"></span>
                </a>
                <div class="panel__header__buttons flex-container row">
                    <div *ngFor="let favorite of userFavorites" class="favourites flex-item">
                        <a class="button button--hover-icon" style="background-color: deepskyblue">
                            <span class="button__text" style="color: white"
                                (click)="showFavorite(favorite)">{{favorite.Name}}</span>
                            <i class="material-icons button__icon" style="color: white" matTooltip="Edit Favourite"
                                [matMenuTriggerFor]="menu2">more_vert</i>
                        </a>



                        <mat-menu #menu2="matMenu">
                            <button mat-menu-item (click)="UpdateFavourite(favorite)">
                                <mat-icon>edit</mat-icon>
                                <span> {{'Update Favourite' | translate | async}}</span>
                            </button>
                            <button mat-menu-item (click)="deleteFavorite(favorite)">
                                <mat-icon>delete_forever</mat-icon>
                                <span>Delete</span>
                            </button>
                        </mat-menu>
                    </div>

                    <div class="fav-divider"></div>
                    <a class="button" (click)="OpenFavourite()">
                        <i class="material-icons button__icon">favorite</i>
                        <span class="button__text">Create Favourite</span>
                    </a>
                    <div class="icon" style="cursor: pointer;" (click)="showAlertDialog()"
                        *ngIf="EnableDashboardAlerts">
                        <mat-icon>notifications_none</mat-icon>
                        <div class="txt" *ngIf="showText" style="cursor: pointer;">{{numberofNotifications}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="panel--search" *ngIf="showSearch" [@enterAnimation]>
            <div class="panel__header">
                <div class="header__title-container" matTooltip="Hide Search" style="cursor: pointer; display: none;">
                    <span class="panel__header__title"></span>
                </div>
                <div class="panel__header__buttons flex-container row" style="margin-right: 2%; margin-left:auto;">
                    <div *ngFor="let favorite of userFavorites" class="favourites flex-item">
                        <a class="button button--hover-icon" style="background-color: deepskyblue">
                            <span class="button__text" style="color: white"
                                (click)="showFavorite(favorite)">{{favorite.Name}}</span>
                            <i class="material-icons button__icon" style="color: white" matTooltip="Edit Favourite"
                                [matMenuTriggerFor]="menu1">more_vert</i>
                        </a>

                        <mat-menu #menu1="matMenu">
                            <button mat-menu-item (click)="UpdateFavourite(favorite)">
                                <mat-icon>edit</mat-icon>
                                <span> {{'Update Favourite' | translate | async}}</span>
                            </button>
                            <button mat-menu-item (click)="deleteFavorite(favorite)">
                                <mat-icon>delete_forever</mat-icon>
                                <span> {{'Delete' | translate | async}}</span>
                            </button>
                        </mat-menu>
                    </div>

                    <div style="margin: 8px;">
                        <div class="chkbox">
                            <mat-checkbox class="filled-in" id="chkHideFavourites" [checked]="hideFavourites"
                                (change)="toggleFavourites()">
                                {{'Hide Favourites' | translate | async}}
                            </mat-checkbox>
                        </div>
                    </div>

                    <div class="fav-divider"></div>
                    <a class="button" (click)="OpenFavourite()">
                        <i class="material-icons button__icon">favorite</i>
                        <span class="button__text"> {{'Create Favourite' | translate | async}}</span>
                    </a>
                    <div class="icon" style="cursor: pointer;" (click)="showAlertDialog()"
                        *ngIf="EnableDashboardAlerts">
                        <mat-icon>notifications_none</mat-icon>
                        <div class="txt" *ngIf="showText" style="cursor: pointer;">{{numberofNotifications}}</div>
                    </div>
                </div>
            </div>
            <search-panel (searchFilters)="getSearchFilters($event)" (selectedTab)="selectedTab"
                (Reset)="ResetFields($event)"></search-panel>
            <ng-container *ngIf="showGraphIcon">
                <i class="material-icons button__icon"
                    style="margin-left: 30px; margin-top: -0.5%; position: absolute;">analytics</i>
                <a (click)="showGraphsBar()" *ngIf="!showGraphBar">
                    <i class="material-icons square-button__icon"
                        style="margin-left: 55px;position: absolute; transform: scale(1) rotate( 90deg);cursor: pointer; margin-top: -0.5%;">forward</i></a>
                <a (click)="showGraphsBar()" *ngIf="showGraphBar">
                    <i class="material-icons square-button__icon"
                        style="margin-left: 55px;  position: absolute;transform: scale(1) rotate( 270deg); cursor: pointer; margin-top: -0.5%;">forward</i></a>
            </ng-container>
        </div>

        <div class="widget-container" *ngIf="showGraphBar">
            <ng-container *ngIf="performSearchImp">
                <ng-container *ngFor="let sP of searchResults">
                    <app-bucket-performance-on-budget-widget
                        [searchParameters]="sP"></app-bucket-performance-on-budget-widget>
                    <app-cost-per-hour-widget [searchParameters]="sP"></app-cost-per-hour-widget>
                    <app-cost-per-ton-widget [searchParameters]="sP"></app-cost-per-ton-widget>
                    <app-cost-per-bcm-widget [searchParameters]="sP"></app-cost-per-bcm-widget>
                    <app-inspection-count-per-jobsite-widget
                        [searchParameters]="sP"></app-inspection-count-per-jobsite-widget>
                </ng-container>
            </ng-container>

        </div>


        <mat-tab-group
            *ngIf="(((selectedUserFavourites?.length > 0) && (!hideFavourites)) || performSearch ) && !hidematgroup"
            [(selectedIndex)]="selectedTab" class="tabs__content"
            (selectedTabChange)="onTabChange($event)">
            <mat-tab label="{{'ASSET VIEW'| translate | async}}" *ngIf="showAssetTab">
                <div class="panel___content" *ngIf="selectedTab == 0">
                    <div id="equipment-implement-list">
                        <!-- <ng-container *ngIf="(selectedUserFavourites?.length > 0) && (!hideFavourites) && !performSearchImp"> -->
                        <ng-container>

                            <ng-container *ngFor="let fav of selectedUserFavourites">
                                <app-implement-overview [favouriteId]="fav.Id"></app-implement-overview>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="performSearchImp">
                            <ng-container *ngFor="let sP of searchResults">
                                <app-implement-overview [searchParameters]="sP"></app-implement-overview>
                            </ng-container>
                        </ng-container>

                    </div>
                </div>
            </mat-tab>

            <mat-tab label="{{'EQUIPMENT VIEW'| translate | async}}" *ngIf="showEqViewTab">
                <div class="panel__content" style="padding-top: 50px;">
                    <div id="equipment-implement-list">
                        <ng-container *ngIf="(selectedUserFavourites?.length > 0) && (!hideFavourites)">
                            <ng-container *ngFor="let fav of selectedUserFavourites">
                                <implements-by-equipment [favouriteId]="fav.Id"></implements-by-equipment>
                            </ng-container>
                        </ng-container>

                        <ng-container *ngIf="performSearch">
                            <ng-container *ngFor="let sP of searchResults">
                                <implements-by-equipment [searchParameters]="sP"></implements-by-equipment>
                            </ng-container>
                        </ng-container>

                    </div>
                </div>
            </mat-tab>





            <mat-tab label="{{'ASSET LOCATION HISTORY'| translate | async}}" *ngIf="showAssetLocationTab"
                (click)="activateLocationSearch()">
                <div id="equipment-implement-list">
                    <ng-container
                        *ngIf="(selectedUserFavourites?.length > 0) && (!hideFavourites) && !performAssetLocationHxSearchImp">
                        <ng-container *ngFor="let fav of selectedUserFavourites">
                            <app-implement-location-history [favouriteId]="fav.Id" [tabReplace]="tabReplace"></app-implement-location-history>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="performAssetLocationHxSearchImp">
                        <ng-container *ngFor="let sP of searchResults">
                            <app-implement-location-history [searchParameters]="sP" [tabReplace]="tabReplace" ></app-implement-location-history>
                        </ng-container>
                    </ng-container>
                </div>
            </mat-tab>
            <mat-tab label="{{'CRACK VIEW'| translate | async}}" *ngIf="showCrackTab">
                <div class="panel__content" style="padding: 0;">
                    <div id="equipment-implement-list" *ngIf="searchParameters && (selectedTab == 2)">
                        <app-implements-crack-view-new [filters]="searchParameters"></app-implements-crack-view-new>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
<div class="emptyscreen" *ngIf="((!emptyFav) && (hideFavourites)) || !performSearch || hidematgroup "> {{'Please use the
    Search field above to select what equipment you are shown.' | translate | async}}</div>